import { StoreState } from "store/index";

export const getAriaLive = (state: StoreState) => state.ariaLive;
